import { Capacitor } from '@capacitor/core';

/**
 * Check if the app is running in a native Capacitor environment
 */
export const isNative = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Get the current platform (ios, android, web)
 */
export const getPlatform = (): string => {
  return Capacitor.getPlatform();
};

/**
 * Detects if the app is running as a PWA (installed on home screen).
 * Used to show full app in PWA and "Mobile coming soon" only in mobile browser.
 */
export const isPWA = (): boolean => {
  if (typeof window === 'undefined') return false;
  // Standalone (Chrome/Edge Android, Safari Add to Home Screen)
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  // Fullscreen / minimal-ui (some PWAs)
  if (window.matchMedia('(display-mode: fullscreen)').matches) return true;
  if (window.matchMedia('(display-mode: minimal-ui)').matches) return true;
  // iOS Safari: launched from home screen
  if ((window.navigator as typeof window.navigator & { standalone?: boolean }).standalone === true) return true;
  return false;
};

/**
 * Detects if the user is on a mobile device (iOS or Android) by user agent only.
 * Does NOT use viewport width — desktop with narrow window stays desktop.
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  return mobileRegex.test(userAgent);
};

/** @deprecated Use isMobileDevice() or useMobile() — kept for compatibility */
export const isMobile = (): boolean => isMobileDevice();

